import axios from "axios";
import Vue from "Vue";
import AppBase from "../AppBase";
import { MenuCollection } from "../../models";


export default class MenuViewApp extends AppBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.lunchData = {
      data: {
        description: "",
        note: [],
        items: []
      }
    };

    this.sweetsData = {
      data: {
        description: "",
        note: [],
        items: []
      }
    };

    this.drinkData = {
      data: {
        description: "",
        note: [],
        category1: {},
        category2: {},
        category3: {},
        category4: {},
        category5: {}
      }
    };

    this.lunchVm = new Vue({
      el: "#js-content-lunch",
      data: this.lunchData
    });

    this.sweetsVm = new Vue({
      el: "#js-content-sweets",
      data: this.sweetsData
    });

    this.drinkVm = new Vue({
      el: "#js-content-drink",
      data: this.drinkData
    });

    axios.get("/wp/menu")
    .then(
      response => {
        this.menu = new MenuCollection().init(response.data);
        this.render();
        this.dispatcher.trigger("init");
      },
      error => {
        console.log(error);
      }
    );
  }

  render() {
    Vue.set(this.lunchData, "data", this.menu.lunch.toJS());
    Vue.set(this.sweetsData, "data", this.menu.sweets.toJS());
    Vue.set(this.drinkData, "data", this.menu.drink.toJS());
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/MenuViewApp.js